import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
	sendSingleMessage,
	getMessageThreads,
	searchThreads,
	getConversation,
	markMessageRead,
	getThreadsWithUnreadMessages
} from 'util/Api';

const updateUnreadMsgs = createAction('thread/updateUnreadMsgs');
const clearSearch = createAction('thread/clearSearch');
const realtimeMsg = createAction('thread/realtimeMsg');

const getThreads = createAsyncThunk(
	'thread/getThreads',
	async ({ pageNumber, inboxType }, { rejectWithValue }) => {
		try {
			return await getMessageThreads(inboxType, pageNumber);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const sendSingle = createAsyncThunk(
	'thread/sendSingle',
	async ({ candidateId, text, actingUser, twilioTemplateId, contentVariables }, { rejectWithValue }) => {
		try {
			return await sendSingleMessage(candidateId, text, actingUser, twilioTemplateId, contentVariables);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const search = createAsyncThunk(
	'thread/search',
	async ({ value, inboxType }, { rejectWithValue }) => {
		try {
			return await searchThreads(value, inboxType);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchConversation = createAsyncThunk(
	'thread/fetchConversation',
	async (
		{ candidateId, markAsRead: markThreadAsRead, threadId, actingUser },
		{ rejectWithValue }
	) => {
		try {
			return await getConversation(candidateId, markThreadAsRead, threadId, actingUser);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const markAsRead = createAsyncThunk(
	'thread/markAsRead',
	async ({ messageId }, { rejectWithValue }) => {
		try {
			return await markMessageRead(messageId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchThreadsWithUnreadMessages = createAsyncThunk(
	'thread/fetchThreadsWithUnreadMessages',
	async ({ inboxType }, { rejectWithValue }) => {
		try {
			return await getThreadsWithUnreadMessages(inboxType);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

export const threadActions = {
	sendSingle,
	markAsRead,
	updateUnreadMsgs,
	getThreads,
	search,
	fetchConversation,
	realtimeMsg,
	fetchThreadsWithUnreadMessages,
	clearSearch
};
